import { ResumeSessionResponse } from "@/D2C/features/auth/utils/resumeJourney";
import { App_Url_New } from "../common/static";
import { axiosInstance } from "./axiosInstance";

export const fetchResumeSession = async (clientId: string, token: string, lobId: number) => {
  const getSessionResponse = await axiosInstance.get<ResumeSessionResponse>(
    `${App_Url_New.ApiEndPoint.getSession}/${clientId}/${lobId}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return getSessionResponse.data;
};
